// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Copyright (c) 2026 Miskulin Technologies. All rights reserved.
// ================================================================
import React, { useState } from 'react';

const APPS = [
  { name: 'CropPatrol', folder: 'FarmHandIQ', industry: 'Agriculture', desc: 'Precision farm management — crop tracking, field mapping, harvest compliance', color: '#367C2B', url: 'farmhandiq.pages.dev', status: 'Live' },
  { name: 'HaulSync', folder: 'FleetsIQ', industry: 'Fleet & Logistics', desc: 'Equipment hauling dispatch, load tracking, driver compliance, route optimization', color: '#3B82F6', url: 'fleetsiq.pages.dev', status: 'Live' },
  { name: 'Directional Ops', folder: 'DirectionalIQ', industry: 'Directional Drilling', desc: '"The Ring" decision loop — survey, min curvature, motor yield, slide calc, steering', color: '#EF4444', url: 'directionaliq.pages.dev', status: 'Live' },
  { name: 'LotSync', folder: 'MotorIQ', industry: 'Auto Dealership', desc: 'Inventory management, deal tracking, service scheduling, compliance reporting', color: '#10B981', url: 'motoriq.pages.dev', status: 'Live' },
  { name: 'NurseVault', folder: 'NurseIQ', industry: 'Healthcare', desc: 'Patient records, shift management, medication tracking, compliance documentation', color: '#EC4899', url: 'nurseiq.pages.dev', status: 'Live' },
  { name: 'NurseVault CA', folder: 'NurseIQ-CA', industry: 'Healthcare (Canada)', desc: 'Canadian healthcare compliance, bilingual, provincial regulation tracking', color: '#EC4899', url: 'nurseiq-ca.pages.dev', status: 'Live' },
  { name: 'Vantage Ops', folder: 'ServiceControlIQ', industry: 'Field Service', desc: 'Multi-trade dispatch, job costing, 6 industry verticals, crew management', color: '#8B5CF6', url: 'servicecontroliq.pages.dev', status: 'Live' },
  { name: 'BudLedger', folder: 'CannabisIQ', industry: 'Cannabis', desc: 'Seed-to-sale tracking, regulatory compliance, inventory management, excise reporting', color: '#22C55E', url: 'cannabisiq.pages.dev', status: 'Live' },
  { name: 'OreSync', folder: 'MiningIQ', industry: 'Mining', desc: 'Mine site operations, safety compliance, equipment tracking, geological data', color: '#D97706', url: 'miningiq.pages.dev', status: 'Live' },
  { name: 'VacTraq', folder: 'VacHaulingIQ', industry: 'Vac Hauling', desc: 'Vacuum truck dispatch, fluid tracking, environmental compliance, ticket management', color: '#6366F1', url: 'vachaulingiq.pages.dev', status: 'Live' },
  { name: 'GlowDesk', folder: 'BeautyIQ', industry: 'Beauty & Salon', desc: 'Appointment booking, client profiles, inventory, revenue tracking, staff scheduling', color: '#F472B6', url: 'beautyiq.pages.dev', status: 'Live' },
  { name: 'ClosingDesk', folder: 'RealEstateIQ', industry: 'Real Estate', desc: 'Listing management, closing workflows, document generation, commission tracking', color: '#14B8A6', url: 'realestateiq.pages.dev', status: 'Live' },
  { name: 'WrenchSync', folder: 'MechanicIQ', industry: 'Mechanic Shop', desc: 'Work orders, parts inventory, customer vehicles, labor tracking, invoicing', color: '#F97316', url: 'mechaniciq.pages.dev', status: 'Live' },
  { name: 'TreadOps', folder: 'TireShopIQ', industry: 'Tire Shop', desc: 'Tire inventory, seasonal tracking, fleet accounts, warranty management', color: '#1E293B', url: 'tireshopiq.pages.dev', status: 'Live' },
  { name: 'HerdLedger', folder: 'CattleIQ', industry: 'Cattle Ranch', desc: 'Herd management, breeding records, veterinary tracking, weight gain analytics', color: '#854D0E', url: 'cattleiq.pages.dev', status: 'Live' },
  { name: 'WellnessIQ', folder: 'WellnessIQ', industry: 'Wellness & Spa', desc: 'Treatment scheduling, client wellness profiles, product sales, membership management', color: '#7C3AED', url: 'wellnessiq.pages.dev', status: 'Live' },
  { name: 'InsuranceBrokerIQ', folder: 'InsuranceBrokerIQ', industry: 'Insurance', desc: 'Policy management, claims tracking, client renewals, commission reconciliation', color: '#0EA5E9', url: 'insurancebrokeriq.pages.dev', status: 'Live' },
  { name: 'StageVault', folder: 'EventVenueIQ', industry: 'Event Venue', desc: 'Event booking, capacity management, vendor coordination, ticketing, compliance', color: '#E11D48', url: 'eventvenueiq.pages.dev', status: 'Live' },
  { name: 'MTIQ', folder: 'CompleteIQ-Internal', industry: 'Internal Tools', desc: 'License management, team directory, app hub, dev tools, meeting briefs', color: '#4F46E5', url: 'completeiq-internal.pages.dev', status: 'Live' },
  { name: 'FormGenius', folder: 'PaperworkIQ', industry: 'Forms & Documents', desc: 'Smart form builder, document templates, digital signatures, compliance filing', color: '#0D9488', url: 'paperworkiq.pages.dev', status: 'Live' },
  { name: 'IOD', folder: 'IslandOverheadDoors', industry: 'Overhead Doors', desc: 'Job dispatch, customer management, crew scheduling, parts inventory, invoicing', color: '#DC2626', url: 'islandoverheaddoors.pages.dev', status: 'Live' },
  { name: 'IronLedger', folder: 'IronLedger', industry: 'Iron & Steel', desc: 'Material tracking, fabrication orders, inventory management, delivery scheduling', color: '#374151', url: 'ironledger.pages.dev', status: 'Live' },
  { name: 'CropPatrol (Broda)', folder: 'BrodaFarms', industry: 'Agriculture (WL)', desc: 'White-label CropPatrol for Broda Farms — full farm management suite', color: '#367C2B', url: 'brodafarms.pages.dev', status: 'Live' },
  { name: 'Hoist Control', folder: 'HoistControlIQ', industry: 'Hoist & Crane', desc: 'Crane operations, load calculations, safety inspections, operator certifications', color: '#EA580C', url: 'hoistcontroliq.pages.dev', status: 'Live' },
  { name: 'RigWarden', folder: 'RigWardenIQ', industry: 'Rig Safety', desc: 'Rig safety compliance, BOP testing, well control, incident reporting, crew certs', color: '#B91C1C', url: 'rigwardeniq.pages.dev', status: 'Live' },
];

const INDUSTRIES = ['All', ...new Set(APPS.map(a => a.industry))];

export default function PortfolioPage() {
  const [filter, setFilter] = useState('All');
  const [search, setSearch] = useState('');
  const [view, setView] = useState('grid');

  const filtered = APPS.filter(a => {
    const matchesIndustry = filter === 'All' || a.industry === filter;
    const matchesSearch = !search || a.name.toLowerCase().includes(search.toLowerCase()) || a.industry.toLowerCase().includes(search.toLowerCase()) || a.desc.toLowerCase().includes(search.toLowerCase());
    return matchesIndustry && matchesSearch;
  });

  return (
    <div className="page-body" style={{ padding: 24 }}>
      {/* Header */}
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ color: 'var(--text)', fontSize: 28, fontWeight: 700, margin: '0 0 4px' }}>
          App Portfolio
        </h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: '0 0 20px' }}>
          25 production apps deployed across 25 industries &mdash; all built from our template engine
        </p>

        {/* Stats */}
        <div style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
          {[
            { label: 'Live Apps', value: '25', color: '#10b981' },
            { label: 'Industries', value: '25', color: '#6366f1' },
            { label: 'Mobile Companions', value: '25', color: '#8b5cf6' },
            { label: 'Total Users', value: '2,400+', color: '#f59e0b' },
            { label: 'White Labels', value: '3', color: '#ec4899' },
          ].map((s, i) => (
            <div key={i} style={{
              padding: '10px 18px', background: 'var(--card)', borderRadius: 10,
              border: '1px solid var(--border)', textAlign: 'center', flex: 1
            }}>
              <div style={{ fontSize: 20, fontWeight: 800, color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 10, color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Filters */}
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <input
            type="text"
            placeholder="Search apps..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{
              padding: '8px 14px', background: 'var(--bg)', border: '1px solid var(--border)',
              borderRadius: 8, color: 'var(--text)', fontSize: 13, width: 220, outline: 'none'
            }}
          />
          <select
            value={filter}
            onChange={e => setFilter(e.target.value)}
            style={{
              padding: '8px 14px', background: 'var(--bg)', border: '1px solid var(--border)',
              borderRadius: 8, color: 'var(--text)', fontSize: 13, outline: 'none'
            }}
          >
            {INDUSTRIES.map(ind => <option key={ind} value={ind}>{ind}</option>)}
          </select>
          <div style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
            {['grid', 'list'].map(v => (
              <button key={v} onClick={() => setView(v)} style={{
                padding: '6px 14px', borderRadius: 6, border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                background: view === v ? '#6366f1' : 'var(--card)',
                color: view === v ? '#fff' : 'var(--text-muted)',
                textTransform: 'capitalize'
              }}>{v}</button>
            ))}
          </div>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
            Showing {filtered.length} of {APPS.length} apps
          </span>
        </div>
      </div>

      {/* Grid View */}
      {view === 'grid' ? (
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14
        }}>
          {filtered.map((app, i) => (
            <div key={i} style={{
              background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)',
              overflow: 'hidden', transition: 'all 0.2s', cursor: 'pointer'
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = app.color; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              {/* Color bar */}
              <div style={{ height: 4, background: app.color }} />
              <div style={{ padding: 18 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--text)', marginBottom: 2 }}>{app.name}</div>
                    <div style={{ fontSize: 11, color: app.color, fontWeight: 600 }}>{app.industry}</div>
                  </div>
                  <span style={{
                    padding: '2px 8px', borderRadius: 10, fontSize: 9, fontWeight: 700,
                    background: 'rgba(16,185,129,0.15)', color: '#10b981', textTransform: 'uppercase'
                  }}>{app.status}</span>
                </div>
                <p style={{ color: 'var(--text-muted)', fontSize: 12, lineHeight: 1.5, margin: '0 0 12px', minHeight: 36 }}>
                  {app.desc}
                </p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: 10, color: 'var(--text-muted)', fontFamily: 'monospace' }}>{app.url}</span>
                  <button
                    onClick={(e) => { e.stopPropagation(); window.open(`https://${app.url}`, '_blank'); }}
                    style={{
                      padding: '4px 12px', background: `${app.color}20`, color: app.color,
                      border: `1px solid ${app.color}40`, borderRadius: 6, fontSize: 10,
                      fontWeight: 600, cursor: 'pointer'
                    }}
                  >Visit</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        /* List View */
        <div style={{
          background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'hidden'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)' }}>
                {['App', 'Industry', 'Description', 'URL', 'Status', ''].map(h => (
                  <th key={h} style={{
                    padding: '12px 14px', textAlign: 'left', fontSize: 11, fontWeight: 600,
                    textTransform: 'uppercase', letterSpacing: 0.5, color: 'var(--text-muted)'
                  }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((app, i) => (
                <tr key={i} style={{ borderBottom: '1px solid var(--border)' }}>
                  <td style={{ padding: '10px 14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <div style={{ width: 8, height: 8, borderRadius: '50%', background: app.color, flexShrink: 0 }} />
                      <span style={{ color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{app.name}</span>
                    </div>
                  </td>
                  <td style={{ padding: '10px 14px', color: 'var(--text-muted)', fontSize: 12 }}>{app.industry}</td>
                  <td style={{ padding: '10px 14px', color: 'var(--text-muted)', fontSize: 12, maxWidth: 300 }}>{app.desc}</td>
                  <td style={{ padding: '10px 14px', color: 'var(--text-muted)', fontSize: 11, fontFamily: 'monospace' }}>{app.url}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <span style={{
                      padding: '2px 8px', borderRadius: 10, fontSize: 10, fontWeight: 700,
                      background: 'rgba(16,185,129,0.15)', color: '#10b981'
                    }}>{app.status}</span>
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <button
                      onClick={() => window.open(`https://${app.url}`, '_blank')}
                      style={{
                        padding: '4px 10px', background: 'rgba(99,102,241,0.1)', color: '#6366f1',
                        border: '1px solid rgba(99,102,241,0.2)', borderRadius: 6, fontSize: 10,
                        fontWeight: 600, cursor: 'pointer'
                      }}
                    >Visit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Tech Stack Banner */}
      <div style={{
        marginTop: 24, padding: 20, background: 'var(--card)', borderRadius: 12,
        border: '1px solid var(--border)', textAlign: 'center'
      }}>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>
          Built With
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 32, flexWrap: 'wrap' }}>
          {['React 18', 'React Router 6', 'Supabase', 'Cloudflare Pages', 'React Native / Expo'].map(tech => (
            <span key={tech} style={{ color: 'var(--text)', fontSize: 14, fontWeight: 600 }}>{tech}</span>
          ))}
        </div>
        <div style={{ marginTop: 12, fontSize: 12, color: 'var(--text-muted)' }}>
          Every app deployed from our proprietary template engine &mdash; 80% code reuse, infinite scalability
        </div>
      </div>
    </div>
  );
}
